import { Spin } from 'antd';

export const PageLoader = () => {
  return (
    <div className='flex justify-center items-center h-screen'>
      <Spin size='large' />
    </div>
  );
};
